var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc-summary-sub-item clearfix"},[_c('div',{staticClass:"item-label pull-left",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.label)+":")]),_c('div',{staticClass:"item-content pull-left",class:`lc-${_vm.contentStyleType}-color`},[(_vm.loading)?[_vm._v("-")]:[_vm._v(_vm._s(_vm.content))]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }